<template>
    <p class="mb-0 text-paragraph">
        <span v-if="totalElements>0">
          Affichage de <span class="fw-bold">{{ ((page-1) * limit) + 1  }}</span>
          à <span class="fw-bold">{{ ((limit * page) > totalElements) ? totalElements : (limit * page) }}</span>
          sur <span class="fw-bold">{{ totalElements }}</span>  enregistrement(s)
        </span>
        <span v-else>
            Aucun enregistrement trouvé
        </span>
    </p>
 
    <nav class="mt-15 mt-md-0 d-flex align-items-center ms-auto" v-if="totalPages > 0">
        <!-- SELECT DE NOMBRE DELEMENT -->
        <label class="mb-0 me-2 small">Par page:</label>
        <select class="form-select form-select-sm select-arrow-right me-3 px-1 py-2 ps-3"
                v-model.number="selectedLimit"
                @change="onLimitChange">
            <option v-for="opt in limitOptions" :key="opt" :value="opt"
                    :selected="opt === selectedLimit">
              {{ opt }}
            </option>
        </select>
        <!-- FIN SELECT -->
 
        <ul class="pagination mb-0">
          <li class="page-item" :class="{disabled:page === 1 }">
              <a class="page-link" href="javascript:;" aria-label="Previous"
                @click="pagination(page-1, limit)">
                <i class="flaticon-chevron-1"></i>
              </a>
          </li>
          <li v-for="n in pageNumbers" :key="n" @click="pagination(n, limit)" class="page-item">
              <a :class="{ active: n === page }" class="page-link" href="javascript:;">{{ n }}</a>
          </li>
          <!-- <li class="page-item" :class="{disabled:(page === totalPages || page === 1) }"> -->
          <li class="page-item" :class="{disabled:(page === totalPages ) }">
              <a class="page-link" href="javascript:;" aria-label="Next"
                @click="pagination(page+1, limit)">
                <i class="flaticon-chevron"></i>
              </a>
          </li>
        </ul>
    </nav>
</template>
 
<script>
import { ref, computed, watch } from 'vue';
 
export default {
    name: 'PaginationComponent',
    emits: ['paginate'],
  // props: ['page', 'totalPages', 'limit','totalElements'],
    props: {
    page: { type: Number, required: true },
    totalPages: { type: Number, required: true },
    limit: { type: Number, required: true },
    totalElements: { type: Number, required: true },
    // Options pour le select
    limitOptions: {
      type: Array,
      default: () => [5, 10, 20, 50, 100]
    }
  },
  setup(props, { emit }) {
 
    const selectedLimit = ref(props.limit ? props.limit : 10);
    watch(() => props.limit, (v) => { selectedLimit.value = v; });
 
    const pageNumbers = computed(() => {
      let numbers = [];
      let start = props.page - 2 > 0 ? props.page - 2 : 1;
      let end = props.page + 2 <= props.totalPages ? props.page + 2 : props.totalPages;
 
      if (start > 1) {
        numbers.push('<<', 1, '...');
      }
 
      for (let i = start; i <= end; i++) {
        numbers.push(i);
      }
 
      if (end < props.totalPages) {
        numbers.push('...', props.totalPages, '>>');
      }
      return numbers;
    });
 
   
 
    const pagination = (page_, limit_) => {
      // emit('paginate', { page_, limit_ });
      // if (typeof page_ === 'number') {
      //   emit('paginate', { page_, limit_ });
      // }
      if (typeof page_ === 'string') {
        switch (page_) {
          case '<<':
            emit('paginate', { page_: 1, limit_ });
            break;
          case '>>':
            emit('paginate', { page_: props.totalPages, limit_ });
            break;
        }
      } else if (typeof page_ === 'number') {
        emit('paginate', { page_, limit_ });
      }
 
    };
 
    const onLimitChange = () => {
        console.log("Selected Limit:", selectedLimit.value);
      emit('paginate', { page_: 1, limit_: selectedLimit.value });
    };
 
    return { pageNumbers, pagination, onLimitChange, selectedLimit };
  },
};
</script>
 
<style scoped>
  .select-arrow-right {
    width: 70px;
    padding-top: 0.75em !important;
    background-position: right 0.5em center;
  }
 
  .page-item .page-link {
    min-width: 40px;
    padding-left: 0.5em;
    padding-right: 0.5em;
    text-align: center;
    display: inline-block;
    white-space: nowrap;
    box-sizing: border-box;
    border: 1px solid #dbdbdb !important;
    /* box-shadow: 10px 10px 5px rgba(0, 0, 0, 0.5) !important; */
  }
</style>
 